import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CLIENT_SUPPORT_HUB_PATH } from '../supportHubPaths';
import './Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="sidebar">
      <div className="sidebar-heading">Music</div>
      <div 
        className="submenu-item active"
        onClick={() => navigate('/master-account/channels')}
      >
        Channels
      </div>
      <div 
        className="submenu-item"
        onClick={() => navigate('/song-library')}
      >
        Song Library
      </div>
      <div 
        className="submenu-item"
        onClick={() => navigate('/master-account/musicuploader')}
      >
        Uploader
      </div>
      <div 
        className="submenu-item"
        onClick={() => navigate('/master-account/musichistory')}
      >
        History
      </div>

      <div className="sidebar-heading">Messaging</div>
      <div 
        className="submenu-item"
        onClick={() => navigate('/master-account/talent-request')}
      >
        Talent Request
      </div>

      <div className="sidebar-heading manage-section">Manage</div>
      <div 
        className="submenu-item"
        onClick={() => navigate('/master-account/account', { 
          state: {
            brandName: location.state?.brandName,
            brandType: location.state?.brandType,
            brandId: location.state?.brandId
          }
        })}
      >
        Account
      </div>
      <div 
        className="submenu-item"
        onClick={() => navigate('/master-account/locations', { 
          state: {
            brandName: location.state?.brandName,
            brandType: location.state?.brandType,
            brandId: location.state?.brandId
          }
        })}
      >
        Locations
      </div>
      <div 
        className="submenu-item"
        onClick={() => navigate('/master-account/billing')}
      >
        Billing
      </div>
      <div 
        className="submenu-item"
        onClick={() => navigate(CLIENT_SUPPORT_HUB_PATH)}
      >
        Support
      </div>
    </div>
  );
};

export default Sidebar; 